'use client';

import { type FC } from 'react';
import { FormProvider } from 'react-hook-form';
import { useTranslations } from 'next-intl';

import { useStore } from '@nanostores/react';

import {
  MerchantsFilters,
  MerchantsList,
  MerchantsListHeader,
} from '@widgets/merchant';

import { $multiDecisionStore, multiDecisionActions } from '@features/merchant';

import { useMultipleSelect } from '@shared/hooks';
import { Box, Flex, Heading, Pagination } from '@shared/ui-kit';

import { useMerchantsPage } from '../hooks';

import { BottomMenu } from './_components';

const MerchantsPage: FC = () => {
  const t = useTranslations('MerchantsPage');

  // multiple select control
  const { isActive } = useStore($multiDecisionStore);
  useMultipleSelect(isActive, multiDecisionActions.resetDecisionSelection);

  const {
    methods,
    merchants,
    error,
    isLoading,
    page,
    pageCount,
    handlePageClick,
  } = useMerchantsPage();

  return (
    <Box pb="36">
      <FormProvider {...methods}>
        <Flex
          direction="column"
          rowGap="20"
        >
          <Flex
            direction="column"
            rowGap="6"
          >
            <Heading>{t('title')}</Heading>
            <Flex
              direction="column"
              rowGap="16"
            >
              <MerchantsFilters
                isLoading={isLoading}
                count={merchants.count}
              />
              <Flex
                direction="column"
                rowGap="4"
              >
                <MerchantsListHeader
                  loading={isLoading}
                  total={merchants.total}
                  count={merchants.count}
                />
                <MerchantsList
                  loading={isLoading}
                  error={error}
                  merchants={merchants}
                />
              </Flex>
            </Flex>
          </Flex>

          {merchants.total > 0 && pageCount > 1 && !isActive && (
            <Pagination
              pageRangeDisplayed={5}
              pageCount={pageCount}
              renderOnZeroPageCount={null}
              onPageChange={handlePageClick}
              forcePage={page - 1}
            />
          )}
        </Flex>

        <BottomMenu />
      </FormProvider>
    </Box>
  );
};

export default MerchantsPage;
